import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@gestor-web/environments/environment';
import { Api } from '../api';
import {
  ApiResponse,
} from './model';

const MODULE_PATH = '/geral';

/**
 *  ORDS-API para Simulador
 */
@Injectable({ providedIn: 'root' })
export class GeralApi extends Api {
  constructor(http: HttpClient) {
    super(`${environment.API_ORDS_BASE_PATH}${MODULE_PATH}`, http);
  }

  fetchPapeisComite() {
    return this.get<ApiResponse<{ cd_comite_papel: number; ds_comite_papel: string }>>('/papeis-comite');
  }
}
